



























































import { Component, Prop, Provide, Vue } from "vue-property-decorator";
import BannerTmp from "./../../common/banner/bannerTop.vue";

@Component({
    components:{
        BannerTmp
    }
})
export default class airpaIndex extends Vue {
    protected bannerData: object = {
        imgUrl: require('../../../../static/images/banner_product.png'),
        title: 'RPA+AI',
        titleTwo: '流程自动化到流程智能化的转变',
        subTitle: '打造端到端企业级流程自动化智能平台'
    };

    public leftList:any = [
        {icon: require('../../../assets/images/product/airpa/airpa_4.svg'), title: '票证识别'},
        {icon: require('../../../assets/images/product/airpa/airpa_5.svg'), title: '手写识别'},
        {icon: require('../../../assets/images/product/airpa/airpa_6.svg'), title: '印章识别'},
        {icon: require('../../../assets/images/product/airpa/airpa_7.svg'), title: '语音合成'},
        {icon: require('../../../assets/images/product/airpa/airpa_8.svg'), title: '文字识别'},
        {icon: require('../../../assets/images/product/airpa/airpa_9.svg'), title: '人脸识别'},
        {icon: require('../../../assets/images/product/airpa/airpa_10.svg'), title: '地址解析'},
        {icon: require('../../../assets/images/product/airpa/airpa_11.svg'), title: '表格识别'}
    ];
    public rightList:any = [
        {icon: require('../../../assets/images/product/airpa/airpa_12.svg'), title: '聊天机器人'},
        {icon: require('../../../assets/images/product/airpa/airpa_13.svg'), title: '文档理解'},
        {icon: require('../../../assets/images/product/airpa/airpa_14.svg'), title: '文本分类'},
        {icon: require('../../../assets/images/product/airpa/airpa_15.svg'), title: '图像分类'},
        {icon: require('../../../assets/images/product/airpa/airpa_16.svg'), title: '目标检测'},
        {icon: require('../../../assets/images/product/airpa/airpa_17.svg'), title: '信息提取'},
        {title: '...'},
        {title: '...'}
    ];
    public results:any = [
        {imgUrl: require('../../../assets/images/product/airpa/airpa_18.png'), title: '视觉赋能',
        des: '人脸识别、图像检测、OCR识别等视觉能力已在政企、营销、安全、工程、网络、财务等领域落地运用，用于业务办理、营销推荐、业务稽核、内容审计、政企稽核等场景，全年总服务20+万次，准确率平均98.5%以上。'}
        ,{imgUrl: require('../../../assets/images/product/airpa/airpa_19.png'), title: '语音赋能',
        des: '语音转写、语音合成等语音能力在综合办公、客户满意度、宽带营销等场景应用落地，通过将投诉语音转写为文字进行满意度分析、运用语音合成和转写构建办公助手、营销助手，全年总服务6+万次，准确率平均92%以上。'}
        ,{imgUrl: require('../../../assets/images/product/airpa/airpa_20.png'), title: '解析赋能',
        des: '语义分析、实体抽取、风险预测、阈值告警等能力在财务、运维、综合、安全、人事等场景应用落地，通过将投诉工单详情进行文本分类、合同文本进行关键信息抽取等等应用极大提升业务智能，全年总服务15+万次，准确率平均93.5%以上。'}
    ]
}
